module.exports = __webpack_public_path__ + "img/face-hand-over-mouth.857bccb6.svg";